import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useAuth } from "../core/AuthContextProvider";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "react-toastify";
import LoadingSpinner from "../common/Loading";

const LoginPage = () => {
  const navigation = useNavigate();
  const [toasting, setToasting] = useState(false);
  const { signIn, userData, authLoading } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const roles = ["fitfreshadmin"];

  useEffect(() => {
    const userHasRequiredRole =
      userData && roles.includes(userData.role) ? true : false;
    if (userHasRequiredRole && userData) {
      navigation("/dashboard");
    }
  }, [userData, loading, authLoading]);

  async function onSubmit(data) {
    setLoading(true);
    try {
      const login = await signIn(data.email, data.password);
      if (!login) {
        setLoading(false);
        toast.error("Invalid email or password", {
          toastId: "login_page",
          onClose: () => {
            setToasting(false);
          },
          onOpen: () => {
            setToasting(true);
          },
        });
      } else {
        setLoading(false);
        navigation("/dashboard");
      }
    } catch (err) {
      toast.error("Invalid email or password", {
        toastId: "login_page",
        onClose: () => {
          setToasting(false);
        },
        onOpen: () => {
          setToasting(true);
        },
      });
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <LoadingSpinner />}
      {(userData || authLoading) && <LoadingSpinner />}
      {!userData && !authLoading && (
        <div className="bg-image">
          <div className="flex items-center h-screen">
            <div className="bg-white p-7 rounded-md w-[500px] mx-auto">
              <div>
                <Link to="/" className="p-4 flex justify-center">
                  <img
                    alt="cleancooler"
                    className="w-30 h-20"
                    src="./images/Fit-Fresh-Logo.png"
                  />
                </Link>
                <h2 className="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
                  Sign In
                </h2>
                {/* "handleSubmit" will validate your inputs before invoking "onSubmit" */}
                <form onSubmit={handleSubmit(onSubmit)}>
                  {/* register your input into the hook by invoking the "register" function */}
                  <div className="intro-x mt-8">
                    <input
                      className="form-control w-full border rounded-md shadow-md py-4 px-5 border border-black-300 mb-5 outline-none"
                      placeholder="Email"
                      {...register("email", {
                        required: {
                          value: true,
                          message: "Please enter a email",
                        },
                        pattern: {
                          value: /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Please enter a valid email",
                        },
                      })}
                    />
                    {errors.email && (
                      <div className="w-[434px] mb-2 -mt-3 text-red-500 text-sm">
                        {errors.email?.message}
                      </div>
                    )}
                    {/* include validation with required or other standard HTML validation rules */}
                    <input
                      type="password"
                      className="form-control w-full border rounded-md shadow-md py-4 px-5 border border-black-300 outline-none"
                      placeholder="Password"
                      {...register("password", {
                        required: {
                          value: true,
                          message: "Please enter a password",
                        },
                      })}
                    />
                    {errors.password && (
                      <div className="w-[434px] mb-2 mt-2 text-red-500 text-sm">
                        {" "}
                        {errors.password?.message}
                      </div>
                    )}
                    {/* errors will return when field validation fails  */}
                  </div>

                  <div className="text-center text-gray-700 justify-between dark:text-gray-600 text-xs sm:text-sm mt-6">
                    <div className="button">
                      <input
                        disabled={toasting}
                        type="submit"
                        value="Submit"
                        className="w-40 px-6 py-3 text-lg cursor-pointer text-white transition-all duration-150 ease-linear rounded-md shadow outline-none bg-[#024C85] hover:bg-yellow-500 hover:shadow-lg focus:outline-none"
                      />
                    </div>
                    <div className="pt-4">
                      <Link
                        to="/forgotpassword"
                        className="text-black hover:text-red-500"
                      >
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginPage;
